import { TYPES } from '@/entities/fields'
import i18n from '@/lang/i18n'

export const COLUMNS = [
    {
        headerName: 'General',
        children: [
            {
                headerName: i18n.t('users.name'),
                field: 'name',
                type: TYPES.STRING,
            },
            {
                headerName: i18n.t('users.email'),
                field: 'email',
                type: TYPES.EMAIL,
            },
            {
                headerName: i18n.t('users.role'),
                field: 'role',
                type: TYPES.STRING,
            },
            {
                headerName: i18n.t('users.createdAt'),
                field: 'createdAt',
                type: TYPES.DATE,
            },
        ],
    },
    // {
    //     headerName: 'Password',
    //     children: [
    //         {
    //             headerName: i18n.t('users.password'),
    //             field: 'password',
    //             type: TYPES.STRING,
    //             value: '*****',
    //         },
    //         {
    //             headerName: i18n.t('users.passwordConfirm'),
    //             field: 'passwordConfirm',
    //             type: TYPES.STRING,
    //             value: '*****',
    //         },
    //     ],
    // },
]

export default {
    columns: COLUMNS,
}
